import { postData, getData } from '@/utils/fetch';
import * as apiType from './type';
import { getOrgId, getOrgIdPath, addClue } from '@/utils/tool';
import { ExchangeRateDetail, VirtualCardDetail } from './type';

const baseUrl = '/api/console/';

// 查询是否共享余额
export function getbBspShareBalanceInfo(business: apiType.businessType) {
  return getData<apiType.BspShare>(baseUrl + 'organization/info/bspShareBalanceInfo', {
    orgId: getOrgId(),
    business,
  });
}

//得到用户支付状态 0 可支付，1 有未支付，2未创建应用
export function getMarketing(business: apiType.businessType) {
  return getData<number>(baseUrl + 'organization/info' + getOrgIdPath('marketing/redirect'), {
    business,
  });
}

//得到whatsapp 列表
export function getWhatsappList() {
  return getData<apiType.WhatsAPPListType>(
    baseUrl + 'organization/info' + getOrgIdPath('waba/list'),
  );
}
//得到OTP 列表
export function getOtpList() {
  return getData<{ appId: string; appName: string }[]>(
    baseUrl + 'organization/info' + getOrgIdPath('otp-business/list'),
  );
}

//得到SMS列表
export function getSmsList() {
  return getData<{ appId: string; appName: string }[]>(
    baseUrl + 'organization/info' + getOrgIdPath('sms-business/list'),
  );
}
//得到报价 如果是whatsapp 需要传wabaId
export function getQuote(business: apiType.businessType, appId?: string) {
  return getData<apiType.quoteType>(baseUrl + 'quotation' + getOrgIdPath(business + '/detail'), {
    appId,
  });
}
//导出报价 如果是whatsapp 需要传wabaId
export function exportQuote(business: apiType.businessType, appId?: string) {
  return getData<any>(
    baseUrl + 'quotation' + getOrgIdPath(business + '/detail/export'),
    appId ? { appId } : {},
    true,
    { buffer: 'array' },
  );
}
//得到折扣
export function getDiscount() {
  return getData<apiType.discountType>(baseUrl + 'order' + getOrgIdPath('discount'));
}
//创建订单
export function orderCreate(params: apiType.orderCreateType) {
  params = Object.assign(params, addClue(params.business));
  return postData<{ id: string; unpaidExisted: boolean; orderId: string }>(
    baseUrl + 'order' + getOrgIdPath('create'),
    params,
  );
}
//订单详情
export function orderDetail(id: string) {
  return getData<apiType.orderDesType>(baseUrl + 'order' + getOrgIdPath('detail/' + id));
}
//订单支付
export function orderPay(id: string, chargeType: string, chainCode?: string) {
  return postData<apiType.payType>(baseUrl + 'order' + getOrgIdPath('charge/' + id), {
    chargeType,
    chainCode,
  });
}
export type Currency = {
  currency: string;
  currencyName: string;
};

export type CountryWithCurrency = {
  countryCode: string;
  countryName: string;
  country: string;
  currencyList: Currency[];
};
// 查询对公支付-国家和币种信息
export function takeCountryAndCurrency() {
  // `${baseUrl}/order/o-${orgId}/bank-transfer-payment/currency-info`
  return getData<CountryWithCurrency[]>(
    baseUrl + 'order' + getOrgIdPath('bank-transfer-payment/currency-info'),
  );
}
// 查询当前账号的处理中的对公支付订单信息（未完成支付的对公支付订单）
export function takeUnpaidOrder() {
  return getData<{ orderNo: string; orderId: string; orgId: string }>(
    baseUrl + 'order' + getOrgIdPath('bank-transfer-payment-detail/order-unpaid'),
  );
}
export type VACard = {
  virtualCardId: string; // VA卡ID
  bizId: string; // VA卡业务ID
  holderName: string; // 持有者名称/银行卡名称 - account name
  bankName: string; // 银行名称 Bank of deposit
  bankLocation: string; // 银行所在地区 Bank location
  accountNo: string; // 账号 Bank Account
  currency: string; // 货币 Currency
  boundExpireTime: number; // 绑定过期时间
  routingNumber?: string; // 北美地区银行代码（Routing Number）
  swiftCode?: string; // 银行国际代码（Swift Code）
  sortCode?: string; // 英国银行代码（Sort Code）
  iban?: string; // 欧盟国际银行帐号（IBAN）
  bankCode?: string; // 中国银行代码
  branchNumber?: string; // 中国支行代码
  companyAddress?: string; // 公司地址
  country?: string; // 开户银行所在国家
  city?: string; // 开户银行所在城市
  address?: string; // 开户银行详细地址
};
// 查询当前绑定的VA卡信息
export function takeBindVACardInfo() {
  return getData<VACard>(baseUrl + 'order' + getOrgIdPath('virtual-card-bind-info'));
}
export type TempVACard = {
  confirmExpireTime?: number; // 过期时间
  paymentStatus: string; // pending
  virtualCardDetail: VirtualCardDetail;
  exchangeRateDetail?: ExchangeRateDetail;
};
// 返回上一步，解除VA卡绑定
export function unbindVACard(
  orderId: string,
  stepOperation: 'backtrack' | 'cancel', // backtrack: 返回上一步 cancel：取消/关闭窗口
  virtualCardId: string,
) {
  return postData<TempVACard>(
    baseUrl + 'order' + getOrgIdPath(`${orderId}/bank-transfer-payment/step-operation`),
    { stepOperation, virtualCardId },
  );
}
// 对公支付点击确定，原来的两步合成一步
export function confirmPayment(
  orderId: string,
  country: string,
  currency: string,
  virtualCardId: string | undefined,
) {
  return postData<unknown>(
    baseUrl + 'order' + getOrgIdPath(`${orderId}/bank-transfer-payment/confirm`),
    { country, currency, virtualCardId },
  );
}

// 补充对公支付订单打款信息
// 提供打款信息，目前仅支持银行卡号
export function provideRemittance(orderId: string, debtorAccountNo: string) {
  return postData<unknown>(
    baseUrl + 'order' + getOrgIdPath(`${orderId}/bank-transfer-payment/extra-payment-info`),
    { debtorAccountNo },
  );
}
// 用户确认了对公支付后，再取消订单
export function cancelOrder(orderId: string) {
  return postData<unknown>(baseUrl + 'order' + getOrgIdPath(`${orderId}/cancel`));
}
//订单列表
export function orderList(params: apiType.orderListType) {
  return getData<apiType.orderListResType>(baseUrl + 'order' + getOrgIdPath('page'), params);
}
//订单列表
export function orderUser() {
  return getData<string[]>(baseUrl + 'order' + getOrgIdPath('email/list'));
}
//帐单列表
export function billList(params: apiType.billListType) {
  return getData<apiType.billListResType>(baseUrl + 'bill' + getOrgIdPath('page'), params);
}
//帐单导出
export function billExport(params: apiType.billListType) {
  return getData<any>(baseUrl + 'bill' + getOrgIdPath('export'), params, true, { buffer: 'array' });
}
//帐单是否有补缴
export function billUnpaid() {
  return getData<boolean>(baseUrl + 'bill' + getOrgIdPath('unpaid'));
}
//帐单补缴创建
export function billCreate(billId: string) {
  return postData<{ id: string }>(baseUrl + 'order' + getOrgIdPath('bill/create'), { billId });
}
//创建税务信息
export function taxCreate(params: apiType.taxInfoType) {
  return postData<number>(baseUrl + 'tax/info' + getOrgIdPath('create'), params);
}
// 校验税务信息(新增或更新税务信息)
export function taxValidate() {
  return postData<number>(baseUrl + 'tax/info' + getOrgIdPath('validateOrHandledTax'));
}
//查询税务信息
export function taxDetail() {
  return getData<apiType.taxDetailType>(baseUrl + 'tax/info' + getOrgIdPath('detail'));
}
//编辑税务信息
export function taxEdit(params: apiType.taxInfoType) {
  return postData<number>(baseUrl + 'tax/info' + getOrgIdPath('edit'), params);
}
//留资
export function contactSales(params: apiType.salesType) {
  return postData<number>(baseUrl + 'website/contact/sales', params);
}
//查询支付状态
export function getPayStatus(id: string) {
  return getData<{ transactionStatus: 'processing' | 'success' | 'failed'; chargeType: string }>(
    baseUrl + 'order' + getOrgIdPath('order-trans/' + id),
  );
}
//查询未支付的帐单也订单数量
export function getUnpaidCount() {
  return getData<{ orderCount: number; billCount: number }>(
    baseUrl + 'order' + getOrgIdPath('order-bill-unpaid-count'),
  );
}
//查询未支付的帐单也订单数量
export function downUrl(params: {
  downType: 'order' | 'bill';
  business: apiType.businessType;
  orderId?: string;
  billId?: string;
  month?: string;
}) {
  return postData<string>(baseUrl + 'order' + getOrgIdPath('order-download'), params);
}

// 根据组织ID判断Push是否支持购买1个月
export function getPushOptions(business: apiType.businessType, appId?: string) {
  return getData<{ customMonth: number }>(
    baseUrl + 'quotation' + getOrgIdPath(business + '/push-options'),
    {
      appId,
    },
  );
}
